export default __webpack_public_path__ + "static/media/loading.6b3b2fe1.gif";